import React from "react";

export default () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="318"
            height="281"
            fill="none"
            viewBox="0 0 318 281"
        >
            <path stroke="#fff" strokeDasharray="5 5" strokeMiterlimit="10"
                  d="M158.792 280c77.113 0 139.626-62.513 139.626-139.626S235.905.748 158.792.748 19.166 63.261 19.166 140.374 81.679 280 158.792 280z"/>
            <path stroke="#fff" strokeMiterlimit="10" strokeWidth="0.25"
                  d="M158.668 260.824c66.718 0 120.804-54.085 120.804-120.803 0-66.718-54.086-120.804-120.804-120.804S37.864 73.302 37.864 140.02c0 66.718 54.086 120.803 120.804 120.803z"/>
            <path stroke="#fff" strokeMiterlimit="10"
                  d="M19.509 68.166h-1.027C6.847 90.582.516 116.077 1.03 142.941c.513 26.864 7.7 52.189 20.02 74.262h1.027C9.756 195.13 2.398 169.977 1.885 142.941c-.343-26.864 5.988-52.36 17.624-74.775zM298.076 212.58h1.027c11.636-22.415 17.967-47.911 17.453-74.775-.513-26.864-7.7-52.189-20.02-74.262h-1.026c12.32 22.073 19.677 47.226 20.191 74.262.513 26.864-5.989 52.36-17.625 74.775zM19.508 68.165l.513-1.026h-1.026l-.514 1.026h1.027z"/>
            <path stroke="#fff" strokeMiterlimit="10"
                  d="M22.076 217.201H21.05l.513 1.027h1.027l-.514-1.027zM295.68 63.544h1.027l-.513-1.026h-1.027l.513 1.026zM298.076 212.58l-.514 1.027h1.027l.513-1.027h-1.026z"/>
        </svg>
    );
}
